import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Postgres `LIKE`/`ILIKE` pattern'inde joker karakterleri (`%`, `_`) ve
// kaçış karakterini (`\`) escape eder. Kullanıcı input'u `ilike("col", \`%${x}%\`)`
// ile sarılırken `x` içindeki `%` veya `_`'i literal'e çevirmek için kullanılır.
// Aksi halde `search="a%"` "a ile başlayan her şey" anlamına gelir (information
// disclosure / DoS riski).
export function escapeLikePattern(value: string): string {
  return value.replace(/[\\%_]/g, "\\$&");
}

// Türkçe karakter ve aksan-insensitive normalizasyon.
// "Şile" ↔ "sile", "Ürgüp" ↔ "urgup", "İzmir" ↔ "izmir" eşleşir.
// i/İ sorununu aşmak için toLocaleLowerCase("tr") kullanıyoruz.
export function normalizeTr(value: string): string {
  return value
    .toLocaleLowerCase("tr")
    .replace(/ş/g, "s")
    .replace(/ı/g, "i")
    .replace(/ğ/g, "g")
    .replace(/ü/g, "u")
    .replace(/ö/g, "o")
    .replace(/ç/g, "c")
    .replace(/â/g, "a")
    .replace(/î/g, "i")
    .replace(/û/g, "u")
    .trim();
}

/**
 * URL'den gelen `?page=` degerini guvenli bir tamsayiya cevirir.
 *
 * NEDEN VAR (O-35): sayfa parametresi hicbir yerde kelepceli degildi.
 * `app/listings/(index)/page.tsx` ham `parseInt(params.page || "1")` yapiyordu:
 * `?page=abc` -> NaN, `?page=-5` -> negatif offset, `?page=99999` -> PostgREST
 * `range()` hatasi -> `getListings` throw -> CANLIDA olculdu: `/listings?page=3`
 * bos govdeli 200 donuyor ve HTML'de sunucu istisnasi (`digest`) var;
 * `/api/listings?page=3` ise 500 donuyordu.
 *
 * Ust sinir da sart: kullanici `?page=1e9` yazarsa offset devasa olur.
 */
export function normalizePageParam(raw: string | number | null | undefined): number {
  const n = typeof raw === "number" ? raw : Number.parseInt(String(raw ?? "1"), 10);
  if (!Number.isFinite(n) || n < 1) return 1;
  return Math.min(Math.floor(n), 10_000);
}
